import * as React from "react"
import cx from "classnames"
import Header from "./header"
import Footer from "./footer"

const Layout = ({ location, children, className }) => {
  const rootPaths = [
    `${__PATH_PREFIX__}/`,
    `${__PATH_PREFIX__}/hubspot-saas/`,
    `${__PATH_PREFIX__}/hubspot-energy/`,
    `${__PATH_PREFIX__}/hubspot-property/`,
  ]
  const isRootPath = rootPaths.includes(location.pathname)

  return (
    <div data-is-root-path={isRootPath} className={cx(className, "font-sans")}>
      <Header isRootPath={isRootPath} />
      <main>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
